import { Component } from '@angular/core';
import { ComponentsModule, slideUp } from '@nx-customer-apps/components';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'vp-info-box',
    templateUrl: './info-box.component.html',
    styleUrls: ['./info-box.component.scss'],
    animations: [slideUp],
    imports: [ComponentsModule, TranslatePipe]
})
export class InfoBoxComponent {
    public isOpened = true;

    public close(): void {
        this.isOpened = false;
    }
}
